import { deleteEmployeeTypes } from "../../../../../actions/Utilities/EmployeeType";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useDeleteEmployeeType = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids) => deleteEmployeeTypes(ids), {
    onSuccess: () => {
      queryClient.invalidateQueries(["GetEmployeeType"]);
      toast.fire(
        "Success",
        "Employee Type were deactivated successfully",
        "success"
      );
    },
    onError: () => {
      toast.fire(
        "Bulk deactivation of Employee Types failed",
        "Server Error: Cannot deactivate Employee Types",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeleteEmployeeType;
